window.am = window.am || {};

window.am.regularExpressionCustomValidator = new function () {
    var that = this;
    that.validationName = 'regularexpressioncustomvalidation';

    that.init = function () {
        that.addValidator(that.validationName);
    };

    that.addValidator = function (validationName) {
        if (!$.validator) {
            return;
        }

        $.validator.addMethod(validationName,
            function (val, element, field) {
                if (this.optional(element)) {
                    return true;
                }

                var regexResult = new RegExp(field.params.pattern, field.params.modifier).exec(val);

                return regexResult && 0 === regexResult.index && regexResult[0].length === val.length;
            }, function (field, element) {
                return field.params.errorMessage || 'Invalid value';
            }
        );


        $('[data-val-' + validationName + ']').each(function (index, element) {
            var validationObj = {};
            validationObj[validationName] = {
                params: {
                    pattern: $(element).data('val-' + validationName + '-pattern'),
                    modifier: $(element).data('val-' + validationName + '-modifier'),
                    errorMessage: $(element).data('val-' + validationName),
                }
            };
            $(element).rules('add', validationObj);
        });
    };
};

window.am.regularExpressionCustomValidator.init();